import { renderTemplatePreviewBlob } from "../reports-and-forms/reports-and-forms";
import {
  createDueDateStatusLabelLookup,
  fetchDueDatePdfContext,
} from "./helpers";

export interface DueDatePdfV2BuildResult {
  blob: Blob;
  filename: string;
}

/**
 * Build due date PDF blob using stationery-v2 payload shape.
 * Mirrors DueDatePreview context preparation.
 */
export async function buildDueDatePdfViaStationeryV2(args: {
  duedateId: number;
  dueDateConfig: { status?: Record<number, string> } | null | undefined;
  status?: string;
}): Promise<DueDatePdfV2BuildResult> {
  const { duedateId, dueDateConfig, status } = args;
  const statusLabelFor = createDueDateStatusLabelLookup(
    dueDateConfig,
    status
  );
  const context = await fetchDueDatePdfContext(duedateId, statusLabelFor);

  const blob = await renderTemplatePreviewBlob(
    "duedate/due_date.html",
    "pdf",
    context
  );
  return { blob, filename: `duedate-${duedateId}.pdf` };
}
